import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class TariffsCitites extends CommonCRUD {}

export default TariffsCitites;
